import { render, staticRenderFns } from "./CTitle.vue?vue&type=template&id=02ca2c7c&scoped=true&"
import script from "./CTitle.vue?vue&type=script&lang=js&"
export * from "./CTitle.vue?vue&type=script&lang=js&"
import style0 from "./CTitle.vue?vue&type=style&index=0&id=02ca2c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca2c7c",
  null
  
)

export default component.exports